import axios from "axios";
import localdomain from "../../utils/constant";
import api from "../../utils/axios-util";
const auth0Config = localdomain();

const common_api_url = auth0Config.login;
export const Asterlogin = (payload) => {
  return (dispatch, getState) => {
    return new Promise(async (resolve, reject) => {
      await api
        .post(`${common_api_url}/v2/oauth/login`, payload)
        .then((response) => {
          resolve(response);
        })
        .catch((err) => {
          reject(err);
        });
    });
  };
};

export const AsterCampaigns = (data) => {
  return (dispatch, getState) => {
    return new Promise(async (resolve, reject) => {
      var apinfo = JSON.parse(localStorage.getItem("apinfo")) || "{}";
      let statedata = getState()
       api.defaults.baseURL = apinfo.api_url;
      api.defaults.headers.common["Authorization"] = `Bearer ${statedata.login.token}`;
      await api
        .get(`/asterdialer/campaigns?user=${data}`)
        .then((response) => {
          resolve(response);
        })
        .catch((err) => {
          reject(err);
        });
    });
  };
};

export const AsterConfig = (payload) => {
  return (dispatch, getState) => {
    return new Promise(async (resolve, reject) => {
      await api
        .get(`${common_api_url}/common/project/config?tenant_code=${payload.tenant_code}&user_email=${payload.user_email}`)
        .then((response) => {
          resolve(response);
        })
        .catch((err) => {
          reject(err);
        });
    });
  };
};

export const LoginUserinfo = (payload) => {
  return (dispatch, getState) => {
    return new Promise(async (resolve, reject) => {
      await api
        .post(`/login`,payload)
        .then((response) => {
          resolve(response);
        })
        .catch((err) => {
          reject(err);
        });
    });
  };
};


export const AuthUserinfo = (DomainPath) => {
  return (dispatch, getState) => {
    return new Promise(async (resolve, reject) => {
      await api
        .get(`${DomainPath}`)
        .then((response) => {
          resolve(response);
        })
        .catch((err) => {
          reject(err);
        });
    });
  };
};

export const logout = (user) => {
  return (dispatch, getState) => {
    return new Promise(async (resolve, reject) => {
      await api
        .post(`/logout`,user)
        .then((response) => {
          resolve(response);
        })
        .catch((err) => {
          reject(err);
        });
    });
  };
};